"use client";

import { cn } from "@/lib/utils";

export type DropdownAuroraGlowVariant = "dropdown" | "modal";

export interface DropdownAuroraGlowProps {
  /**
   * `dropdown` — fade corto al fondo del panel (menús navbar).
   * `modal` — fade largo que disuelve los gradientes en el cuerpo blanco del modal.
   */
  variant?: DropdownAuroraGlowVariant;
}

/**
 * Aurora en la parte superior de dropdowns (navbar user menu) y modales v2.
 * Mismos tonos que CardColorEclipse, sin animación y con fade a fondo sólido.
 */
export function DropdownAuroraGlow({ variant = "dropdown" }: DropdownAuroraGlowProps) {
  const isModal = variant === "modal";

  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-x-0 top-0 z-0 overflow-hidden",
        isModal ? "h-56 sm:h-64" : "h-44"
      )}
    >
      <div
        className="absolute -left-10 -top-12 h-32 w-32 rounded-full blur-2xl"
        style={{
          background:
            "radial-gradient(circle, rgba(34,211,238,0.42) 0%, rgba(34,211,238,0.16) 40%, transparent 72%)"
        }}
      />
      <div
        className="absolute -right-10 -top-12 h-32 w-32 rounded-full blur-2xl"
        style={{
          background:
            "radial-gradient(circle, rgba(251,146,60,0.38) 0%, rgba(251,146,60,0.14) 40%, transparent 72%)"
        }}
      />
      <div
        className="absolute left-1/2 -top-6 h-28 w-36 -translate-x-1/2 rounded-full blur-2xl"
        style={{
          background:
            "radial-gradient(circle, rgba(167,139,250,0.32) 0%, rgba(99,102,241,0.14) 48%, transparent 74%)"
        }}
      />
      <div
        className="absolute right-[14%] -top-2 h-24 w-24 rounded-full blur-2xl"
        style={{
          background:
            "radial-gradient(circle, rgba(236,72,153,0.28) 0%, rgba(236,72,153,0.08) 45%, transparent 70%)"
        }}
      />
      <div
        className="absolute left-[8%] top-2 h-20 w-20 rounded-full blur-xl"
        style={{
          background:
            "radial-gradient(circle, rgba(16,185,129,0.22) 0%, rgba(16,185,129,0.06) 50%, transparent 72%)"
        }}
      />
      <div
        className={cn(
          "absolute inset-x-0",
          isModal
            ? "inset-y-0 bg-gradient-to-b from-transparent from-[8%] via-white/25 via-[38%] via-white/55 via-[58%] via-white/82 via-[78%] to-white to-100% dark:via-zinc-950/25 dark:via-zinc-950/55 dark:via-zinc-950/82 dark:to-zinc-950"
            : "bottom-0 h-24 bg-gradient-to-b from-transparent via-white/70 to-white dark:via-zinc-950/75 dark:to-zinc-950"
        )}
      />
    </div>
  );
}
